var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map-root",staticClass:"open-map",staticStyle:{"width":"100%","height":"150px"}})}
var staticRenderFns = []

export { render, staticRenderFns }